import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { baseUrl } from '../../../environments/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ChartTypeService {

  constructor(
    private http: HttpClient,
    private storagesrv: StorageService
  ) {}

  // GET /chart/recent-view-tickers - Get user's recently viewed tickers
  getRecentViewTickers(disableHttpLoader = 'true') {
    return this.http.get(`${baseUrl}/chart/recent-view-tickers`, {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer' + ' ' + this.storagesrv.get('token'))
        .set('disableHttpLoader', disableHttpLoader),
    });
  }

  // GET /chart/chart-types-list - Get chart types with favorite status
  getChartTypesList(disableHttpLoader = 'true') {
    return this.http.get(`${baseUrl}/chart/chart-types-list`, {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer' + ' ' + this.storagesrv.get('token'))
        .set('disableHttpLoader', disableHttpLoader),
    });
  }

  // PUT /chart/favorite-chart-type/:chartTypeId - Toggle favorite chart type
  toggleFavoriteChartType(chartTypeId: string, disableHttpLoader = 'true') {
    return this.http.put(`${baseUrl}/chart/favorite-chart-type/${chartTypeId}`, {}, {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer' + ' ' + this.storagesrv.get('token'))
        .set('disableHttpLoader', disableHttpLoader),
    });
  }

  // GET /chart/chart-indicators-list - Get chart indicators with favorite status
  getChartIndicatorsList(disableHttpLoader = 'true') {
    return this.http.get(`${baseUrl}/chart/chart-indicators-list`, {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer' + ' ' + this.storagesrv.get('token'))
        .set('disableHttpLoader', disableHttpLoader),
    });
  }

  // PUT /chart/favorite-chart-indicator/:chartIndicatorId - Toggle favorite indicator
  toggleFavoriteChartIndicator(chartIndicatorId: string, disableHttpLoader = 'true') {
    return this.http.put(`${baseUrl}/chart/favorite-chart-indicator/${chartIndicatorId}`, {}, {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer' + ' ' + this.storagesrv.get('token'))
        .set('disableHttpLoader', disableHttpLoader),
    });
  }

  // POST /chart/update-chart-settings - Update user chart settings
  updateChartSettings(settings: any, disableHttpLoader = 'true') {
    return this.http.post(`${baseUrl}/chart/update-chart-settings`, settings, {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer' + ' ' + this.storagesrv.get('token'))
        .set('disableHttpLoader', disableHttpLoader),
    });
  }

  // GET /chart/get-chart-settings - Get user chart settings
  getChartSettings(disableHttpLoader = 'true') {
    return this.http.get(`${baseUrl}/chart/get-chart-settings`, {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer' + ' ' + this.storagesrv.get('token'))
        .set('disableHttpLoader', disableHttpLoader),
    });
  }

  // GET /chart/chart-time-ranges-list - Get time ranges with default marked
  getChartTimeRangesList(disableHttpLoader = 'true') {
    return this.http.get(`${baseUrl}/chart/chart-time-ranges-list`, {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer' + ' ' + this.storagesrv.get('token'))
        .set('disableHttpLoader', disableHttpLoader),
    });
  }

  // GET /chart/chart-intervals-list - Get intervals with default marked
  getChartIntervalsList(disableHttpLoader = 'true') {
    return this.http.get(`${baseUrl}/chart/chart-intervals-list`, {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer' + ' ' + this.storagesrv.get('token'))
        .set('disableHttpLoader', disableHttpLoader),
    });
  }
}

